// extracted by mini-css-extract-plugin
export default {"notificacao":"NotificacaoErro_notificacao__zKMsa","mostrar":"NotificacaoErro_mostrar__bcV0b"};